/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellularAlt2Bar: {
  name: 'signal-cellular-alt-2-bar';
  data: string;
} = {
  name: 'signal-cellular-alt-2-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 14h3v6H5v-6zm6-5h3v11h-3V9z"/></svg>`
};
